import React from 'react';
import { VERSION_DISPLAY } from '../../config/version';
import { Sparkles } from 'lucide-react';

const Footer = ({ showLogo = true, showVersion = true, centered = false, className = "" }) => {
  return (
    <footer className={`py-12 border-t border-zinc-800 ${className}`}>
      <div className="max-w-7xl mx-auto px-4">
        <div className={`flex flex-col ${centered ? 'items-center text-center' : 'md:flex-row items-center justify-between'} gap-4`}>
          {showLogo && (
            <div className="flex items-center gap-2">
              <img 
                src="/echokit-logo.png" 
                alt="EchoKit" 
                className="h-12 w-auto opacity-50"
              />
            </div>
          )}
          <div className="flex flex-col items-center gap-1">
            <p className="text-zinc-500 text-sm">
              © 2026 EchoKit. Making podcast promotion effortless.
            </p>
            {showVersion && (
              <div className="flex items-center gap-2">
                <Sparkles className="w-3 h-3 text-emerald-400" />
                <span className="text-zinc-600 text-xs">
                  {VERSION_DISPLAY}
                </span>
              </div>
            )}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
